<template>
  <div>
    <e-charts autoresize :options="pie" ref="pie" auto-resize style="height:329px"/>
    <p class="px-6 text-center font-semibold">% positive sentiments</p>
    <div class="flex justify-center items-center gap-x-6 px-6">
      <feather-icon
        icon="FrownIcon"
        class="p-3 inline-flex rounded-full"
        :class="[`text-blue`]"
      ></feather-icon>
      <div>
        <div class="inline-block align-text-bottom bg-blue-pink-300 rounded-full w-5 h-5 mr-1"></div>
        0-60%,
      </div>
      <div>
        <div class="inline-block align-text-bottom bg-blue-pink-700 rounded-full w-5 h-5 mr-1"></div>
        60-80%
      </div>
      <div>
        <div class="inline-block align-text-bottom bg-blue-pink-900 rounded-full w-5 h-5 mr-1"></div>
        >80%
      </div>
      <feather-icon
        icon="SmileIcon"
        class="p-3 inline-flex rounded-full"
        :class="[`text-pink`]"
      ></feather-icon>
    </div>
  </div>
</template>

<style>
  /* todo create tailwind color properties and classes */
  .bg-blue-pink-300 {
    background-color: #6c6cb5
  }
  .bg-blue-pink-700 {
    background-color: #b15996;
  }
  .bg-blue-pink-900 {
    background-color: #d34f87;
  }
</style>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/pie'

export default {
  props: {
      intentions: {
          type: Array,
          required: true
      }
  },
  computed: {
    pie() {
      return {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} <br/> {c} Calls ({d}%)'
        },
        series: [
          {
            name: 'Reasons for service calls',
            type: 'pie',
            center: ['50%', '50%'],
            label: {
              fontSize: 14,
              lineHeight: 16,
              fontFamily: 'Montserrat, sans-serif',
            },
            color: this.chartColors(),
            //color: ['#28C76F','#EA5455','#87ceeb','#7367F0'],
            data: this.chartData(),
            //roseType: 'radius',
            radius: '60%',
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              },
              borderWidth: 1,
              borderColor: '#ffffff'
            },
            grid: { containLabel: true },
          }
        ],
        grid: { containLabel: true },
      }
    }
  },
  methods: {
    chartData(){
        let data = [];
        for (let elem of this.intentions) {
          data.push({value: elem.reviews*1, name: elem.measure + (elem.measure.length > 1 ? '\n' : ' ') +'(' + elem.sentiment + '%)'});
        }
        return data;
    },
    chartColors(){
        let colors = [];
        for (let elem of this.intentions) {
          switch (Math.ceil(elem.sentiment/10)){
            case 1:
              colors.push("#4a76c4"); break;
            case 2:
              colors.push("#5b71bc"); break;
            case 3:
              colors.push("#6c6cb5"); break;
            case 4:
              colors.push("#7d67ad"); break;
            case 5:
              colors.push("#8e62a5"); break;
            case 6:
              colors.push("#a05e9e"); break;
            case 7:
              colors.push("#b15996"); break;
            case 8:
              colors.push("#c2548e"); break;
            case 9:
              colors.push("#d34f87"); break;
            case 10:
              colors.push("#e44a7f"); break;
            default:
              colors.push("#cccccc"); break;
          }
          //console.log(elem.sentiment + " " + Math.ceil(elem.sentiment/10))
        }
        //return ['#FF9F43','#28C76F','#EA5455','#87ceeb','#7367F0'];
        return colors;

    }
  },
  components: {
    ECharts
  },
  mounted () {
    let dataIndex = -1
    let pie = this.$refs.pie
    let dataLen = pie.options.series[0].data.length

  }
}
</script>

